import React, { useState, useEffect, useRef } from 'react';
import {getLeftBanner, getSocialLinks } from './requests';
import SvgArrow from '../Svg/SvgArrow';
import './index.css';

function SliderBanner({type}) {
    const [openLeftBanner, setOpenLeftBanner] = useState(false);
    const [openRightBanner, setOpenRightBanner] = useState(false);
    const [socialLinks, setSocialLinks] = useState([]);
    const [leftBannerData, setLeftBannerData] = useState({});
    const leftBannerRef = useRef(null)
    let bannerBody;

    const heightBannerLinkContainer = 212;
    const heightBannerLink = 70;
    const visibliLinks = 3;
    const defaultPercentageReduction = 1;
    const { innerWidth } = window;
    const defaultContentWidth = 1398;
    const defaultBannerControlWidth = 46;
    const scrollBarWidth = 16;
    const maxWidthBanner = 258;
    const heightOpenBannerLinks = heightBannerLinkContainer
        + heightBannerLink * (socialLinks.length - visibliLinks);

    const getcontentWidth = () => {
        if (innerWidth < 1900 && innerWidth > 1600) {
            return (defaultContentWidth * 90) / 100;
        }
        if (innerWidth < 1600 && innerWidth > 1400) {
            return (defaultContentWidth * 80) / 100;
        }
        if (innerWidth < 1400 && innerWidth > 1200) {
            return (defaultContentWidth * 70) / 100;
        }
        return defaultContentWidth;
    };
        
    const getBannerControlWidth = () => {
        if (innerWidth < 1900 && innerWidth > 1600) {
            return (defaultBannerControlWidth * 90) / 100;
        }
        if (innerWidth < 1600 && innerWidth > 1400) {
            return (defaultBannerControlWidth * 80) / 100;
        }
        if (innerWidth < 1400 && innerWidth > 1200) {
            return (defaultBannerControlWidth * 70) / 100;
        }
        return defaultBannerControlWidth;
    };
        
    const getPercentageReduction = () => {
        if (innerWidth < 1900 && innerWidth > 1600) {
            return (defaultPercentageReduction * 90) / 100;
        }
        if (innerWidth < 1600 && innerWidth > 1400) {
            return (defaultPercentageReduction * 80) / 100;
        }
        if (innerWidth < 1400 && innerWidth > 1200) {
            return (defaultPercentageReduction * 70) / 100;
        }
        return defaultPercentageReduction;
    };
    const percentageReduction = getPercentageReduction();
    const contentWidth = getcontentWidth();
    const bannerControlWidth = getBannerControlWidth();
        
    const freeWidth = (innerWidth - contentWidth - scrollBarWidth) / 2 - bannerControlWidth;
    // const bannerWidth = freeWidth / percentageReduction > maxWidthBanner
    //     ? maxWidthBanner
    //     : freeWidth / percentageReduction;

    async function processingRequest() {
        setSocialLinks((await getSocialLinks()).data);
        setLeftBannerData((await getLeftBanner()).data);
    }
    useEffect(() => {
        processingRequest();
        console.log(leftBannerData);
    }, []);

    // console.log("leftBannerRef", leftBannerRef);

    switch (type) {
        case "left":
            if (leftBannerData.active) {
                bannerBody = 
                <div className="left-side slider-banner" >
                    <div className="left-banner" ref={leftBannerRef}>
                        <a href={leftBannerData.link} target="_blank" rel="noreferrer">
                        <div
                            className="hide-banner"
                            style={
                            openLeftBanner
                                ? { width: `${leftBannerRef.current.clientHeight}px`, right: `-${leftBannerRef.current.clientHeight}px` }
                                : { width: '0', transitionDelay: '0.6s', right: '0' }
                            }
                        >
                            <div
                            className="hide-banner__item"
                            style={
                                openLeftBanner
                                ? { transform: 'translate(0%)' }
                                : { transform: 'translate(-100%)' }
                            }
                            >
                            <div className="hide-banner__content">
                                <img src={leftBannerData.picture && leftBannerData.picture[0]} alt="Крутое предложение" />
                            </div>
                            </div>
                        </div>
                        </a>
                
                        <div 
                        // style={{ position: 'absolute' }} 
                        onClick={() => {
                            setOpenLeftBanner(!openLeftBanner);
                        }}>
                        <div>
                            <div className="banner__link-title">
                            <span>{leftBannerData.title}</span>
                            </div>
                        </div>
                        <div className="banner-button__left">
                            <div
                            className="banner-button__arrow"
                            style={
                                openLeftBanner
                                ? { transform: 'rotate(0deg)', transition: 'all 0.6s' }
                                : { transform: 'rotate(180deg)', transition: 'all 0.6s' }
                            }
                            >
                            <SvgArrow color="purple" direction="left" />
                            </div>
                        </div>
                        </div>
                    </div>
                </div>;
            } else {
                bannerBody = "";
            }
            break;
        case "right":
            bannerBody = 
            <div className="right-side slider-banner">
                <div className="right-banner">
                    <div
                    className="banner__link-container"
                    style={
                        openRightBanner
                        ? {
                            height: `${heightOpenBannerLinks}px`,
                            transition: 'all 0.6s',
                        }
                        : { transition: 'all 0.6s' }
                    }
                    >
                    {socialLinks.map((el, index) => (
                        <div
                        key={index.toString()}
                        className="banner__link-item"
                        >
                        <a
                            href={el.link}
                            target="_blank"
                            rel="noreferrer"
                        >
                            {/* eslint-disable-next-line jsx-a11y/mouse-events-have-key-events */}
                            <img
                            // onMouseOver={(event) => {
                            //   // eslint-disable-next-line no-param-reassign
                            //   event.currentTarget.src = image;
                            // }}
                            // onMouseOut={(event) => {
                            //   // eslint-disable-next-line no-param-reassign
                            //   event.currentTarget.src = el.picture;
                            // }}
                            src={el.picture}
                            alt={el.title}
                            className="social-img"
                            />
                        </a>
                        </div>
                    ))}
                    </div>
                    { socialLinks.length > 3
                    && (
                    <div className="banner-button__right">
                        <div
                        onClick={() => {
                            setOpenRightBanner(!openRightBanner);
                        }}
                        style={
                            openRightBanner
                                ? { transform: 'rotate(90deg)', transition: 'all 0.6s' }
                                : { transform: 'rotate(270deg)', transition: 'all 0.6s' }
                            }
                        >
                        <SvgArrow color="purple" direction="left" />
                        </div>
                    </div>
                    )}
                </div>
            </div>;
            break;
    }
    return bannerBody;
}

export default SliderBanner;